/**
 * Logger utility for frontend
 * Provides consistent logging interface
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  info: (message: string, data?: any) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.log(`[INFO] ${message}`, data || '');
    }
  },
  warn: (message: string, data?: any) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.warn(`[WARN] ${message}`, data || '');
    }
  },
  error: (message: string, error?: any) => {
    // eslint-disable-next-line no-console
    console.error(`[ERROR] ${message}`, error || '');
    // Em produção, poderia enviar para serviço de monitoramento
  },
  debug: (message: string, data?: any) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.debug(`[DEBUG] ${message}`, data || '');
    }
  }
};
